import { Pipe, PipeTransform } from '@angular/core';
import { MarketplacePermission } from '@libs/authentication/services';

@Pipe({ name: 'avatarName' })
export class AvatarNamePipe implements PipeTransform {
  transform(user: MarketplacePermission): string {
    const firstName = user?.firstName?.trim();
    const lastName = user?.lastName?.trim();

    if (!user || (!firstName && !lastName)) {
      return 'Account Info';
    }

    // trimming is important, with extra space part of the name won't be shown
    return firstName + ' ' + lastName;
  }
}
